import './WhatsappConsent.module.less'
import { Button, Drawer } from 'antd'
import PhoneIcon from '../assets/PhoneIcon.svg'
import WhatsappIcon from '../assets/WhatsappIcon.svg'

type ConsentProps = {
  schoolName: string
  consentAction: Function
}

export default function WhatsappConsent({
  schoolName,
  consentAction,
}: ConsentProps) {
  return (
    <>
      <Drawer
        height="270"
        className="whatsApp-drawer"
        title={
          <div className="phone-icon">
            <PhoneIcon />
          </div>
        }
        placement="bottom"
        maskClosable={false}
        onClose={() => consentAction('CLOSE')}
        visible
      >
        <div className="whatsApp-update">
          <p className="whatsApp-text">Feature update!</p>
          <p className="whatsApp-description">
            {schoolName} would like to send your school updates on
            <WhatsappIcon style={{ marginBottom: '-9px' }} />
            Whatsapp!
          </p>
          <Button
            onClick={() => consentAction('SAVE')}
            className="whatsApp-btn"
          >
            Yes, I'm in!
          </Button>
        </div>
      </Drawer>
    </>
  )
}
